export const menuItemSx = {
    borderRadius: '7px',
    p: 1,
    gap: 1,
    '&:hover': { 
      bgcolor: 'action.hover',
      '& .MuiListItemIcon-root': {
        color: '#02042D',
      }
    }
};

export const TabIconSx = {
    fontSize: 20,
};

export const phoneNumberStyleSx = {
  inputStyle: {
    width: '100%',
    height: '3rem',
    fontSize: '1rem',
    paddingLeft: '3rem',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
  buttonStyle: {
    border: 'none',
    background: 'none',
    borderRadius: '8px 0 0 8px',
  },
  containerStyle: {
    width: '100%',
  },
  inputProps: (error) => ({
    name: 'PhoneNumber',
    required: true,
    label: 'Phone Number',
    placeholder: 'Enter a phone number',
    'aria-label': 'Phone Number',
    'aria-required': 'true',
    'aria-invalid': !!error,
    'aria-errormessage': error ? 'phone-error' : undefined,
  }),
};


export const textFieldSx = {
    height: '100%',
    justifyContent: 'center',
    borderColor: '#E5E7EB',
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        backgroundColor: '#fff',
        '& fieldset': {
            borderColor: '#E5E7EB',
        },
        '&:hover fieldset': {
            borderColor: '#bdbdbd',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#E5E7EB',
        },
        '&.Mui-disabled': {
            backgroundColor: '#f0f0f0',
        },
    },
    '& .MuiInputBase-input': {
        padding: '12px 14px',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center', 
    },
    '& .MuiSelect-select': {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        alignContent: 'center',
        padding: '10px 14px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
        '&[aria-expanded="false"]': {
            // justifyContent: 'center',
        },
        '& fieldset': {
            borderColor: '#EDEDED',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#E5E7EB',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.2)',
        },
    },
    '& .MuiSelect-icon': {
        right: '14px',
    },
    '& .Mui-disabled .MuiInputBase-input': {
        color: '#757575',
    },
};
export const SecondaryButtonSx = {
    width: '100%',
    color: "#02042D",
    borderColor: "gray",
    textTransform: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "12px",
    "&:hover": {
        borderColor: "#02042D",
    },
    border: '1px solid #E5E7EB',
  };

  export const menuSx = {
    overflow: 'visible',
    mt: 1.2, // Slightly reduced margin top
    borderRadius: '14px', // Slightly tighter border radius
    minWidth: '200px', // Reduced width
    '& .MuiList-root': {
    padding: '12px', // Slightly reduced padding
    },
    '&:before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 18,
    width: 10,
    height: 10,
    bgcolor: 'background.paper',
    transform: 'translateY(-50%) rotate(45deg)',
    zIndex: 0,
    },
    };
  export const paginationSx = {
    display: 'flex',
    justifyContent: 'center',
    mt: 3,
    '& .MuiPaginationItem-root': {
      borderRadius: '0.75rem', // 12px - slightly larger for a smoother appearance
      fontWeight: 500,
      fontSize: '0.9rem',
      minWidth: '38px',
      height: '38px',
      color: '#1F2937',
      transition: 'all 0.2s ease-in-out',
      border: '1px solid #E5E7EB',
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: '#F9FAFB', // slightly lighter than #F3F4F6
        borderColor: '#D1D5DB',
      },
    },
    '& .MuiPaginationItem-root.Mui-selected': {
      backgroundColor: '#02042D',
      color: '#FFFFFF',
      border: '1px solid #02042D',
      '&:hover': {
        backgroundColor: '#1C1D3D',
        borderColor: '#1C1D3D',
      },
    },
  };
  
  
  export const ButtonSx = ({ loading, creditError, width}) => ({
    width: width || "auto",
    backgroundColor: (loading || creditError) ? "#A9A9A9" : "#02042D",
    color: "#FFF",
    textTransform: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 500,
    "&:hover": {
      bgcolor: "#010320",
    },
    "&.Mui-disabled": {
      bgcolor: "#e0e0e0",
      color: "#9e9e9e",
    },
  });
  
  export const PublishButtonSx={
    whiteSpace: 'nowrap',  // Prevents text from wrapping
    bgcolor: "#02042D",
    color: "#FFF",
    width: "auto",
    textTransform: "none",
    borderRadius: 999,
    padding: "8px 24px",
    fontSize: 13,
    "&:hover": {
        bgcolor: "#010320",
    },
    "&.Mui-disabled": {
        bgcolor: "#e0e0e0",
        color: "#9e9e9e",
    },
  }

export const ChipSx = {
        bgcolor: '#FFFFFF',
        padding: '6px 12px',
        fontSize: '12px',
        border: '1px solid #E5E7EB',
        fontWeight: '500',
        height: '32px',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiChip-label': {
        display: 'flex',
        alignItems: 'center',
        },
};

export const SecondaryChipSx = {
    backgroundColor: '#F3F4F6',
    borderRadius: '999px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#111827',
    height: '28px',
    px: 1.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiChip-label': {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      marginLeft: '8px',
      paddingLeft: '4px',
      paddingRight: '8px',
    },
    border: 'none',
    boxShadow: 'none',
  };

